import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import useUserContext from '../../hooks/use-user-context';
import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';

import Link from '../Link';
import TextRenderer from '../TextRenderer';

const Menu = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: ${rem(-12)};
  font-size: ${rem(14)};
`;

const MenuItem = styled.li`
  padding: ${rem(12)};
`;

const MenuLink = styled(Link)`
  color: ${colors.gray['600']};
  transition: color .2s ease;

  &:hover {
    color: ${colors.blue['800']};
    text-decoration: underline;
  }

  ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
    color: ${colors.gray['400']};
    &:hover {
      color: ${colors.blue['100']};
    }
  `}
`;

const FooterUtilityMenu = ({ className }) => {
  const data = useStaticQuery(graphql`
    query FooterUtilityMenu {
      allContentfulNavigation(filter: {location: {eq: "footer-utility"}}) {
        nodes {
          ...NavigationFragment
        }
      }
    }
  `);
  const { language } = useUserContext();
  const contentfulNavigation = data.allContentfulNavigation.nodes.find(
    (navigation) => navigation.language === language
  );
  const { navigationItems } = contentfulNavigation;

  return (
    <Menu className={className}>
      {navigationItems.map((navigationItem) => (
        <MenuItem key={navigationItem.id}>
          <MenuLink
            to={navigationItem.url}
            targetBlank={navigationItem.targetBlank}
          >
            <TextRenderer text={navigationItem.title} />
          </MenuLink>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default FooterUtilityMenu;
